import { LoginPage } from '@/components/pages';

export default function Home() {
  return <LoginPage />;
}
